<template>
	<el-dialog
		:modelValue="open"
		@update:modelValue="$emit('update:open', $event)"
		:title="isActive ? 'User deaktivieren' : 'User reaktivieren'"
		:before-close="(done) => dialogBeforeClose(done, waiting)"
	>
		<el-alert
			v-if="isActive"
			:title="'Sind Sie sicher? Der gewählte User wird dauerhaft deaktiviert. Alle verbleibenden Daten werden nach X Tagen automatisch gelöscht. Er kann in diesem Zeitraum wieder reaktiviert werden.'"
			type="error"
			:closable="false"
			effect="dark"
			show-icon
		/>
		<el-alert
			v-else
			:title="'Sind Sie sicher? Der gewählte User wird wieder aktiviert. Alle Daten bleiben erhalten.'"
			type="success"
			:closable="false"
			effect="dark"
			show-icon
		/>

		<el-alert :title="errorMsg" type="error" v-if="error" />

		<template #footer>
			<div class="button-panel">
				<TheButton v-if="isActive" type="danger" @buttonclick="handleActivateUser" :disabled="waiting">Deaktivieren</TheButton>
				<TheButton v-else type="danger" @buttonclick="handleActivateUser" :disabled="waiting">User reaktivieren</TheButton>

				<TheButton type="default" @buttonclick="$emit('update:open', false)">Abbrechen</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TheButton from '../TheButton.vue';
import { UserResponse, UserStatus } from '../../types/types';
import { startLoading, stopLoading } from '@/utils/loading/loadingHandler';
import { activateUser, deactivateUser } from '@/requests/users';
import { texts } from '../../utils/texts';
import { dialogBeforeClose } from '@/utils/functions';

export default defineComponent({
	name: 'DialogHandleUserActivation',
	components: {
		TheButton,
	},
	data() {
		return {
			waiting: false,
			error: false,
			errorMsg: '',
		};
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
		user: {
			type: Object as () => UserResponse,
			required: true,
		},
	},
	emits: ['reload', 'update:open'],
	computed: {
		isActive() {
			return this.user.status === UserStatus.Active;
		},
	},
	methods: {
		async handleActivateUser() {
			this.waiting = true;
			const loading = startLoading('#user');

			let result;
			if (this.isActive) {
				result = await deactivateUser(this.user.id);
			} else {
				result = await activateUser(this.user.id);
			}

			if (result.success) {
				this.$emit('reload');
				this.$emit('update:open', false);
			} else {
				this.error = true;
				if (this.isActive) {
					this.errorMsg = texts.user.deactivationFailed;
				} else {
					this.errorMsg = texts.user.activationFailed;
				}
			}

			this.waiting = false;
			stopLoading(loading);
		},
		dialogBeforeClose,
	},
});
</script>
